import React from 'react';
import { CheckCircle, FileText, StickyNote, Activity, Bell } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const MILESTONE_5_FEATURES = [
  {
    icon: FileText,
    title: 'Doctor Consultation Summary',
    desc: 'Generate a professional PDF summary of your symptoms to share with your doctor before appointments.',
    color: 'indigo'
  }
];

const MILESTONE_10_FEATURES = [
  {
    icon: FileText,
    title: 'Doctor Consultation Summary',
    desc: 'Professional PDF symptom summaries for doctor appointments.',
    color: 'purple'
  },
  {
    icon: StickyNote,
    title: 'Patient Notes',
    desc: 'Add detailed notes to your symptom entries for richer health records.',
    color: 'purple'
  },
  {
    icon: Activity,
    title: 'Trigger Tracking',
    desc: 'Identify and track what triggers your symptoms over time.',
    color: 'purple'
  },
  {
    icon: Bell,
    title: 'Doctor Appointment Reminders',
    desc: 'Never miss a doctor appointment with smart reminders.',
    color: 'purple'
  }
];

const colorMap = {
  indigo: {
    bg: 'bg-indigo-50',
    border: 'border-indigo-200',
    icon: 'text-indigo-600 bg-indigo-100',
    check: 'text-indigo-500',
    title: 'text-indigo-900',
    desc: 'text-indigo-700'
  },
  purple: {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    icon: 'text-purple-600 bg-purple-100',
    check: 'text-purple-500',
    title: 'text-purple-900',
    desc: 'text-purple-700'
  }
};

const UnlockedFeatures = ({ milestone }) => {
  const features = milestone === 10 ? MILESTONE_10_FEATURES : MILESTONE_5_FEATURES;
  const color = milestone === 10 ? 'purple' : 'indigo';
  const c = colorMap?.[color];

  return (
    <div className={`rounded-2xl border-2 p-6 mb-6 ${c?.bg} ${c?.border}`}>
      <h2 className={`text-lg font-bold mb-4 flex items-center gap-2 ${c?.title}`}>
        <CheckCircle className={`w-5 h-5 ${c?.check}`} />
        {milestone === 10 ? 'All Premium Features Unlocked' : 'Feature Unlocked'}
      </h2>
      <div className="space-y-4">
        {features?.map((feature, idx) => {
          const Icon = feature?.icon;
          return (
            <div key={idx} className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${c?.icon}`}>
                <Icon className="w-5 h-5" />
              </div>
              <div>
                <p className={`font-semibold text-sm ${c?.title}`}>{feature?.title}</p>
                <p className={`text-xs mt-0.5 leading-relaxed ${c?.desc}`}>{feature?.desc}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UnlockedFeatures;
